export const UTF8_BOM = "\uFEFF";
const ROW_END = "\r\n";
const NEEDS_QUOTES = /[",\r\n]/;
const FORMULA_START = /^[=+@\t\r]/;
const NEGATIVE_NUMBER = /^-\d+(\.\d+)?$/;

function isFormulaLike(value: string): boolean {
  if (FORMULA_START.test(value)) return true;
  return value.startsWith("-") && value.length > 1 && !NEGATIVE_NUMBER.test(value);
}

export function csvCell(value: string): string {
  const safe = isFormulaLike(value) ? `'${value}` : value;
  return NEEDS_QUOTES.test(safe) ? `"${safe.replace(/"/g, '""')}"` : safe;
}

export function buildCsv(rows: readonly (readonly string[])[]): string {
  return UTF8_BOM + rows.map((row) => row.map(csvCell).join(",") + ROW_END).join("");
}
